import { useState, useEffect } from 'react';
import { creatorsService } from '@/services/creators';
import { Creator, GetCreatorsParams } from '@/types/creators';

export const useCreators = (params?: GetCreatorsParams) => {
  const [creators, setCreators] = useState<Creator[]>([]);
  const [total, setTotal] = useState(0);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const fetchCreators = async () => {
    try {
      setLoading(true);
      const defaultParams: GetCreatorsParams = {
        offset: 0,
        limit: 100,
        ...params
      };
      const response = await creatorsService.getAll(defaultParams);
      setCreators(response.data || []);
      setTotal(response.total || 0);
      setError(null);
    } catch {
      setError('Failed to load creators');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchCreators();
  }, [params]);

  return { creators, total, loading, error, refetch: fetchCreators };
};
